import { useState, useEffect } from 'react';
import automobyApi from '../Api';
import { useUpdateQueryParams, useReadQueryParams } from './useQueryParams';
import { toIntOrDefault } from '../utils/ints';
import { formatDate } from '../utils/date';
import { baseFileURL } from '../Api';

export const useCar = (defaultPageSize) => {
  const [cars, setCars] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCars, setTotalItems] = useState(0);
  const [totalPaidCars, setTotalPaidCars] = useState(0);

  const [sum, setSum] = useState({ ClientDebt: 0, CompanyDebt: 0, Pwin: 0, Rwin: 0 })
  const [firstReached, setFirstReached] = useState(false)
  const updateQueryParams = useUpdateQueryParams();

  const defaultConfig = {
    all: true,
    limit: defaultPageSize,
    order_by: "purchased_at",
    page: 1,
    dealer_id: 0,
    saler_id: 0,
    sender_country_id: 0,
    reciever_country_id: 0,
    sender_at_min: "",
    sender_at_max: "",
    bonus_done_date_min: "" ,
    bonus_done_date_max: "" , 
    reciever_at_min: "",
    reciever_at_max: "",
    purchased_at_min: "",
    purchased_at_max: "",
    status_id: 0,
    discount_id:0,
    dealer_option_id:0,
    percent_id:0,
    vin: "",
    client_query: "",
    search_query: "",
    is_deleted: false,
    is_archive: false,
    custom_filter: 0,
  }

  const initData = (car) => {
    const defaultClient = {
      id: 0,
      firstname: "",
      lastname: "",
      personal: "",
      email: "",
      password: "",
      mobile: ""
    };

    let client_price_transfer_fee_def = 60;
    let saler_price_transfer_fee_def = 60;
    let car_price_transfer_fee_def = 10;

    if(baseFileURL === 'https://finance.automoby.ge') {
      client_price_transfer_fee_def = 30;
      saler_price_transfer_fee_def = 30;
      car_price_transfer_fee_def = 30;
    }

    let currentDate = new Date();
    let formattedDate = formatDate(currentDate);

    return {
      id: car?.id || 0,
      maker_id: car?.maker?.id || 0,
      model_id: car?.model?.id || 0,
      website_id: car?.website?.id || 0,
      saler_id: car?.saler?.id || 0,
      dealer_id: car?.dealer?.id || (car?.dealer === null ? 0 : null),
      purchased_at: car?.purchased_at || formattedDate,
      vin: car?.vin || '',
      lot: car?.lot || '',
      prod_year: car?.prod_year || 0,
      client: car?.client || defaultClient,
      client_id: car?.client?.id || 0,
      export_country_id: car?.export_country?.id || 0,
      export_city_id: car?.export_city?.id || 0,
      sender_country_id: car?.sender_country?.id || 0,
      sender_city_id: car?.sender_city?.id || 0,
      reciever_country_id: car?.reciever_country?.id || 0,
      reciever_city_id: car?.reciever_city?.id || 0,
      transport_price_id: car?.transport_price?.id || 0,
      transport_price: car?.transport_price ,
      status_id: car?.status?.id || 1,
      marine_line_id: car?.marine_line?.id || 0,
      container_number: car?.container_number || '',
      bl_number: car?.bl_number || '',
      reciever_at: car?.reciever_at || "",
      sender_at: car?.sender_at || "",
      insurance: car?.insurance || 0,
      source_id: car?.source_id || 0,
      fund_accept: car?.fund_accept || false,
      discount_accept: car?.discount_accept || false,
      client_deposit: car?.client_deposit || 0,
      client_price_car: car?.client_price_car || 0,
      client_price_transport: car?.client_price_transport || 0,
      client_price_internal: car?.client_price_internal || 0,
      client_price_dealer: car?.client_price_dealer || 0,
      client_price_dealer_transport: car?.client_price_dealer_transport || 0,
      client_price_document: car?.client_price_document || 0,
      client_price_insurance: car?.client_price_insurance || 0,
      client_price_penalty: car?.client_price_penalty || 0,
      client_price_transfer_fee: car?.client_price_transfer_fee !== undefined ? car.client_price_transfer_fee : client_price_transfer_fee_def,
      client_price_another: car?.client_price_another || 0,
      client_price_fund: car?.client_price_fund || 0,
      client_percent_fund: car?.client_percent_fund !== undefined ? car.client_percent_fund : 10,
      client_price_discount: car?.client_price_discount || 0,
      saler_price_car: car?.saler_price_car || 0,
      saler_price_transport: car?.saler_price_transport || 0,
      saler_price_internal: car?.saler_price_internal || 0,
      saler_price_dealer: car?.saler_price_dealer || 0,
      saler_price_dealer_transport: car?.saler_price_dealer_transport || 0,
      saler_price_document: car?.saler_price_document || 0,
      saler_price_insurance: car?.saler_price_insurance || 0,
      saler_price_penalty: car?.saler_price_penalty || 0,
      saler_price_transfer_fee: car?.saler_price_transfer_fee !== undefined ? car.saler_price_transfer_fee : saler_price_transfer_fee_def,
      saler_price_another: car?.saler_price_another || 0,
      saler_price_fund: car?.saler_price_fund || 0,
      saler_percent_fund: car?.saler_percent_fund !== undefined ? car.saler_percent_fund : 10,
      saler_price_discount: car?.saler_price_discount || 0,
      car_price_car: car?.car_price_car || 0,
      car_price_transport: car?.car_price_transport || 0,
      car_price_internal: car?.car_price_internal || 0,
      car_price_dealer: car?.car_price_dealer || 0,
      car_price_dealer_transport: car?.car_price_dealer_transport || 0,
      car_price_document: car?.car_price_document || 0,
      car_price_insurance: car?.car_price_insurance || 0,
      car_price_penalty: car?.car_price_penalty || 0,
      car_price_transfer_fee: car?.car_price_transfer_fee !== undefined ? car.car_price_transfer_fee : car_price_transfer_fee_def,
      car_price_another: car?.car_price_another || 0,
      correct_price: car?.correct_price || 0,
      car_price_fund: car?.car_price_fund || 0,
      car_percent_fund: car?.car_percent_fund || 0,
      car_price_discount: car?.car_price_discount || 0,

      client_price_inspection: car?.client_price_inspection || 0,
      saler_price_inspection: car?.saler_price_inspection || 0,
      car_price_inspection: car?.car_price_inspection || 0,
      service: car?.service || 1, 
    };
  }

  const [filter, setFilter] = useState(useReadQueryParams(defaultConfig));

  useEffect(() => {
    if (defaultPageSize > 0) {
      setCars([]); 
      fetchCars(); 
      listSum();
    }
  }, [filter]);

  const resetDefault = () => {
    setFilter(defaultConfig)
  }

  const fetchCars = async () => {
    try {
      updateQueryParams(filter);
      console.log(filter)
      const response = await automobyApi.post("/car/list", filter)
      setCars(response.data.cars);
      setTotalItems(response.data.total);
      setTotalPaidCars(response.data.total_paid_car)
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }


  const fetchAllCars = async () => {
    try {
      updateQueryParams(filter);
      const response = await automobyApi.post("/car/all", filter)
      return response.data
    } catch (error) { 
      console.error("თუ ერორია:" + error);
    }
  }
 
 
  const listSum = async () => {
    try {
      const response = await automobyApi.post("/car/sum", filter)
      setSum(response.data)
    } catch (error) {
      console.error("თუ ერორია:" + error);
    }
  }

  

  const getStat = async () => {
    try {
      const response = await automobyApi.post("/car/statistic", filter)
      return response.data
    } catch (error) {
      console.error("თუ ერორია:" + error);
    }
  }

  const statByYear = (year, saler_id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          year: parseInt(year, 10),   
          saler_id: parseInt(saler_id, 10)  
        };
  
        const response = await automobyApi.post(`/car/statistic/year`, requestData);
        resolve(response.data);
      } catch (error) {
        console.error(error);
        if (error.response && error.response.data && error.response.data.message) {
          reject(error.response.data.message);
        } else {
          reject(error);
        }
      }
    });
  };
   
  const getCarById = async (id) => {
    try {

      const requestData = {
        id: Number(id)
      };

      const response = await automobyApi.post("/car/one", requestData)
      return response.data.car
    } catch (error) {
      console.error("ერორი:" + error);
    }
  }
   
  const getCarPhotosById = async (id) => {
    try {

      const requestData = {
        id: Number(id)
      };

      const response = await automobyApi.post("/car/photos", requestData)
      return response.data.car
    } catch (error) {
      console.error("ერორი:" + error);
    }
  }


  const getCarPhotosDownloadById = (id, name) => {
    automobyApi({
      url: `/car/photos/download`,
      method: 'POST',
      responseType: 'blob',
      data: { name: name, car_id: id }
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${id}.zip`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => console.error('Download failed:', error));
  };


  

  const addCar = (car) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          car: car
        };

        const response = await automobyApi.post(`/car/add`, requestData);
        fetchCars();
        listSum();
        resolve(response.data);
      } catch (error) {
        console.error(error);
        if (error.response && error.response.data && error.response.data.message) {
          reject(error.response.data.message);
        } else {
          reject(error);
        }
      }
    });
  };

  const addCarPage = (car) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          car: car
        };

        const response = await automobyApi.post(`/car/add`, requestData);
        resolve(response.data);
      } catch (error) {
        console.error(error);
        if (error.response && error.response.data && error.response.data.message) {
          reject(error.response.data.message);
        } else {
          reject(error);
        }
      }
    });
  };


  const updateCar = (car) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          car: car
        };

        const response = await automobyApi.post(`/car/update`, requestData);
        fetchCars();
        listSum();

        resolve(response.data);
      } catch (error) {
        console.error(error);

        if (error.response && error.response.data && error.response.data.message) {
          reject(error.response.data.message);
        } else {
          reject('Failed to update the car');
        }
      }
    });
  }

  const updateCarPage = (car) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          car: car
        };

        const response = await automobyApi.post(`/car/update`, requestData);
        resolve(response.data);
      } catch (error) {
        console.error(error);

        if (error.response && error.response.data && error.response.data.message) {
          reject(error.response.data.message);
        } else {
          reject('Failed to update the car');
        }
      }
    });
  }

  const deleteCar = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          car_id: id
        };
        const response = await automobyApi.post(`/car/delete`, requestData);
        fetchCars();
        listSum();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  }

  const updateStatus = async (carId, statusId) => {
    try {

      const requestData = {
        car_id: carId,
        status_id: statusId,
      };
      const response = await automobyApi.post("/car/update/status", requestData)
    } catch (error) {
      console.error(error);
    }
  }

  const updateMarine = async (carId, marineLineId) => {
    try {

      const requestData = {
        car_id: carId,
        marine_line_id: marineLineId,
      };
      const response = await automobyApi.post("/car/update/marine-line", requestData)
    } catch (error) {
      console.error(error);
    }
  }

  const updateFeedbackId = async (carId, FeedbackId) => {
    try {

      const requestData = {
        car_id: carId,
        feedback_id: FeedbackId,
      };
      const response = await automobyApi.post("/car/update/feedback", requestData)
    } catch (error) {
      console.error(error);
    }
  }

  const updateFeedbackServiceId = async (carId, FeedbackId) => {
    try {

      const requestData = {
        car_id: carId, 
        feedback_service_id: FeedbackId,
      };
      const response = await automobyApi.post("/car/update/feedback-service", requestData)
    } catch (error) {
      console.error(error);
    }
  }

  const updateDocIssuer = async (carId, docIssuer) => {
    try {

      const requestData = {
        car_id: carId,
        doc_issuer: docIssuer,
      };
      const response = await automobyApi.post("/car/update/doc/issuer", requestData)
    } catch (error) {
      console.error(error);
    }
  }

  const updateFinalRecipient = async (carId, e) => {
    try {

      const requestData = {
        car_id: carId,
        final_recipient_firstname: e.final_recipient_firstname, 
        final_recipient_lastname: e.final_recipient_lastname, 
        final_recipient_personal: e.final_recipient_personal, 
        final_recipient_mobile: e.final_recipient_mobile, 
        };
        
      const response = await automobyApi.post("/car/update/final-recipient", requestData)
 
    } catch (error) {
      console.error(error);
    }
  }


  const updateInsurance = async (carId, insurance) => {
    try {

      const requestData = {
        car_id: carId,
        insurance: insurance,
      };
      const response = await automobyApi.post("/car/update/insurance", requestData)
    } catch (error) {
      console.error(error);
    }
  }

  const updateService = async (carId, service) => {
    try {

      const requestData = {
        car_id: carId,
        service: service,
      };
      const response = await automobyApi.post("/car/update/service", requestData)
    } catch (error) {
      console.error(error);
    }
  }

  const updateContainerNumber = async (carId, containerNumber) => {
    try {

      const requestData = {
        car_id: carId,
        container_number: containerNumber,
      };
      const response = await automobyApi.post("/car/update/container", requestData)
    } catch (error) {
      console.error(error);
    }
  }

  const updateTransitNumber = async (carId, transitNumber) => {
    try {

      const requestData = {
        car_id: carId,
        transit_number: transitNumber,
      };
      const response = await automobyApi.post("/car/update/transit", requestData)
    } catch (error) {
      console.error(error);
    }
  }


  const updateBlNumber = async (carId, bl_number) => {
    try {

      const requestData = {
        car_id: carId,
        bl_number: bl_number,
      };
      const response = await automobyApi.post("/car/update/blnumber", requestData)
    } catch (error) {
      console.error(error);
    }
  } 


 


const updateSenderAt = async (newData) => {
  try {
    const response = await automobyApi.post(`/car/update/sender/at`, newData);
    return response.data;
  } catch (error) {
    console.error(error);
  } 
}


  const updateDepositPaid = async (carId, amount) => {
    try {

      const requestData = {
        car_id: carId,
        amount: amount,
      };
      const response = await automobyApi.post("/car/update/deposit", requestData)
      fetchCars();
    } catch (error) {
      console.error(error);
    }
  }



  const updateClientPrice = async (car) => {
    try {
      const requestData = {
        car: {
          id: car.id,
          client_price_car: car.client_price_car,
          client_price_transport: car.client_price_transport,
          client_price_internal: car.client_price_internal,
          client_price_dealer: car.client_price_dealer,
          client_price_dealer_transport: car.client_price_dealer_transport,
          client_price_document: car.client_price_document,
          client_price_insurance: car.client_price_insurance,
          client_price_penalty: car.client_price_penalty,
          client_price_deposit: car.client_price_deposit,
          client_price_transfer_fee: car.client_price_transfer_fee,
          client_price_another: car.client_price_another,
          client_transport_saler_price: car.client_transport_saler_price,
          client_price_fund: car.client_price_fund,
          client_percent_fund: car.client_percent_fund,
          saler_price_fund: car.saler_price_fund,
          saler_percent_fund: car.saler_percent_fund,
          fund_accept: car.fund_accept,
          client_price_discount: car.client_price_discount,
          discount_accept: car.discount_accept
        },
      };
      const response = await automobyApi.post("/car/update/price/client", requestData)
      fetchCars();
      listSum();

      //updateLocal(car)
    } catch (error) {
      console.error(error);
    }
  }

  const updateCompanyPrice = async (car) => {
    try {
      const requestData = {
        car: {
          id: car.id,
          car_price_car: car.car_price_car,
          car_price_transport: car.car_price_transport,
          car_price_internal: car.car_price_internal,
          car_price_dealer: car.car_price_dealer,
          car_price_dealer_transport: car.car_price_dealer_transport,
          car_price_document: car.car_price_document,
          car_price_insurance: car.car_price_insurance,
          car_price_penalty: car.car_price_penalty,
          car_price_deposit: car.car_price_deposit,
          car_price_transfer_fee: car.car_price_transfer_fee,
          car_price_another: car.car_price_another,
          correct_price: car.correct_price,
          car_price_fund: car.car_price_fund,
          car_percent_fund: car.car_percent_fund,
          car_price_discount: car.car_price_discount,
        },
      };
      const response = await automobyApi.post("/car/update/price/company", requestData)
      fetchCars();
      listSum();
      //updateLocal(car)
    } catch (error) {
      console.error(error);
    }
  }

  const updateSalerPrice = async (car) => {
    try {
      const requestData = {
        car: {
          id: car.id,
          saler_price_car: car.saler_price_car,
          saler_price_transport: car.saler_price_transport,
          saler_price_internal: car.saler_price_internal,
          saler_price_dealer: car.saler_price_dealer,
          saler_price_dealer_transport: car.saler_price_dealer_transport,
          saler_price_document: car.saler_price_document,
          saler_price_insurance: car.saler_price_insurance,
          saler_price_penalty: car.saler_price_penalty,
          saler_price_deposit: car.saler_price_deposit,
          saler_price_transfer_fee: car.saler_price_transfer_fee,
          saler_price_another: car.saler_price_another,
          saler_transport_saler_price: car.saler_transport_saler_price,
          saler_price_fund: car.saler_price_fund,
          saler_percent_fund: car.saler_percent_fund,
          saler_price_discount: car.saler_price_discount,

        },
      };
      const response = await automobyApi.post("/car/update/price/saler", requestData)
      fetchCars();
      listSum();
      //updateLocal(car)
    } catch (error) {
      console.error(error);
    }
  }

  const updateColorComment = async (id, color, comment) => {
    try {
      const requestData = {
        car: {
          id: id,
          color: color,
          comment: comment,
        },
      };
      const response = await automobyApi.post("/car/update/color/comment", requestData)
      fetchCars();
      listSum();
      //updateLocal(car)
    } catch (error) {
      console.error(error);
    }
  }

  const updateLocal = async (car) => {
    setCars(cars.map(item =>
      item.id === car.id ? car : item
    ));
  }

  const nextPage = () => setCurrentPage(currentPage + 1);
  const prevPage = () => setCurrentPage(currentPage - 1);

  const fetchAppData = async () => {
    try {
      const response = await automobyApi.post("/app/data")
      return response.data
    } catch (error) {
      console.error("ერორი:" + error);
    }
  }


  const fetchByDealerId = (dealerId) => {
    return new Promise((resolve, reject) => {
      const requestData = {
        dealer_id: dealerId,
      };

      automobyApi
        .post("/car/dealer", requestData)
        .then(response => {
          resolve(response.data.cars);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  const fetchByDealerIdDebt = (dealerId) => {
    return new Promise((resolve, reject) => {
      const requestData = {
        dealer_id: dealerId,
      };

      automobyApi
        .post("/car/dealer/debt", requestData)
        .then(response => {
          resolve(response.data.cars);
        })
        .catch(error => {
          reject(error);
        });
    });
  };



  const fetchByDealerIdDeposit = (dealerId) => {
    return new Promise((resolve, reject) => {
      const requestData = {
        dealer_id: dealerId,
      };

      automobyApi
        .post("/car/dealer/deposit", requestData)
        .then(response => {
          resolve(response.data.cars);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  const fetchClientPrices = (carId) => {
    return new Promise((resolve, reject) => {
      const requestData = {
        car_id: carId,
      };

      automobyApi
        .post("/log/client/prices", requestData)
        .then(response => {
          resolve(response.data.logs);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  const downloadFile = (id, name) => {
    automobyApi({
      url: `/image/download`,
      method: 'POST',
      responseType: 'blob',
      data: { name: name, car_id: id }
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${id}.zip`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => console.error('Download failed:', error));
  };
 
  const downloadExcel = (id, name) => {
    automobyApi({
      url: `/car/excel`,
      method: 'POST',
      responseType: 'blob',
      data: filter
    })
      .then((response) => {
        const currentDate = new Date();
        const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
        const formattedTime = `${currentDate.getHours()}-${currentDate.getMinutes()}-${currentDate.getSeconds()}`;
        const fileName = `excel_${formattedDate}_${formattedTime}.xlsx`;

        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => console.error('Download failed:', error));
  };
 
  const downloadPdfBonus = (id, name) => {
    automobyApi({
      url: `/car/bonus/pdf`,
      method: 'POST',
      responseType: 'blob',
      data: filter
    })
      .then((response) => {
        const currentDate = new Date();
        const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
        const formattedTime = `${currentDate.getHours()}-${currentDate.getMinutes()}-${currentDate.getSeconds()}`;
        const fileName = `excel_${formattedDate}_${formattedTime}.pdf`;

        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => console.error('Download failed:', error));
  };

  const downloadReport = (dates) => {
    automobyApi({
      url: `/car/report`,
      method: 'POST',
      responseType: 'blob',
      data: { filter: filter, min: dates.min, max: dates.max }
    })
      .then((response) => {
        const currentDate = new Date();
        const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
        const formattedTime = `${currentDate.getHours()}-${currentDate.getMinutes()}-${currentDate.getSeconds()}`;
        const fileName = `excel_${formattedDate}_${formattedTime}.xlsx`;

        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => console.error('Download failed:', error));
  };


  const uploadInvoice = (invoice) => {
    return new Promise((resolve, reject) => {

      automobyApi
        .post("/car/invoice/company/upload/", invoice)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const sumPrices = (prices) => {
    return prices.reduce((total, price) => total + toIntOrDefault(price), 0);
  };

  const calculateFundIncrease = (basePrice, percent, accept) => {
    if (accept && percent > 0 && percent < 100) {
      return Math.floor((basePrice * percent) / 100);
    }
    return 0;
  };

  const calculatePrice = (newCar) => {
    const clientPrices = [
      newCar.client_price_car, 
      newCar.client_price_transport,
      newCar.client_price_internal, 
      newCar.client_price_dealer,
      newCar.client_price_dealer_transport,
      newCar.client_price_document,
      newCar.client_price_insurance,
      newCar.client_price_penalty,
      newCar.client_price_transfer_fee, 
      newCar.client_price_another, 
      newCar.client_price_inspection
    ];

    const salerPrices = [
      newCar.saler_price_car, 
      newCar.saler_price_transport,
      newCar.saler_price_internal, 
      newCar.saler_price_dealer,
      newCar.saler_price_dealer_transport,
      newCar.saler_price_document,
      newCar.saler_price_insurance, 
      newCar.saler_price_penalty,
      newCar.saler_price_transfer_fee, 
      newCar.saler_price_another, 
      newCar.saler_price_inspection
    ];

    const companyPrices = [
      newCar.car_price_car, 
      newCar.car_price_transport,
      newCar.car_price_internal, 
      newCar.car_price_dealer,
      newCar.car_price_dealer_transport,
      newCar.car_price_document,
      newCar.car_price_insurance,
      newCar.car_price_penalty,
      newCar.car_price_transfer_fee,
      newCar.car_price_another,
      newCar.correct_price, 
      newCar.car_price_inspection
    ];

    let clientPrice = sumPrices(clientPrices);
    let salerPrice = sumPrices(salerPrices);
    let companyPrice = sumPrices(companyPrices);
    let clientPercent = calculateFundIncrease(newCar.client_price_fund, newCar.client_percent_fund, newCar.fund_accept)
    let salerPercent = calculateFundIncrease(newCar.saler_price_fund, newCar.saler_percent_fund, newCar.fund_accept);
    let companyPercent = calculateFundIncrease(newCar.car_price_fund, newCar.car_percent_fund, newCar.fund_accept);


    clientPrice += clientPercent
    salerPrice += salerPercent
    companyPrice += companyPercent

 
    if(newCar.discount_accept) {
      clientPrice = clientPrice - newCar.client_price_discount
      //salerPrice = salerPrice - newCar.saler_price_discount
     // companyPrice = companyPrice - newCar.car_price_discount
    }
      // salerPrice = salerPrice - newCar.saler_price_discount
      companyPrice = companyPrice - newCar.car_price_discount


    return {
      clientPrice,
      salerPrice,
      companyPrice,
      clientPercent,
      salerPercent,
      companyPercent
    };
  };

  const resetPrices = (car) => {
    const updatedCar = {
      ...car,
      client_price_car: 0,
      client_price_transport: 0,
      client_price_internal: 0,
      client_price_dealer: 0,
      client_price_dealer_transport: 0,
      client_price_document: 0,
      client_price_insurance: 0,
      client_price_penalty: 0,
      client_price_transfer_fee: 0,
      client_price_another: 0,
      client_price_fund: 0,
      client_percent_fund: 0,
      client_price_discount: 0,
  
      saler_price_car: 0,
      saler_price_transport: 0,
      saler_price_internal: 0,
      saler_price_dealer: 0,
      saler_price_dealer_transport: 0,
      saler_price_document: 0,
      saler_price_insurance: 0,
      saler_price_penalty: 0,
      saler_price_transfer_fee: 0,
      saler_price_another: 0,
      saler_price_fund: 0,
      saler_percent_fund: 0,
      saler_price_discount: 0,
  
      car_price_car: 0,
      car_price_transport: 0,
      car_price_internal: 0,
      car_price_dealer: 0,
      car_price_dealer_transport: 0,
      car_price_document: 0,
      car_price_insurance: 0,
      car_price_penalty: 0,
      car_price_transfer_fee: 0,
      car_price_fund: 0,
      car_percent_fund: 0,
      car_price_another: 0,
      car_price_discount: 0,
      correct_price: 0,
    };
  
    return updatedCar;
  };
 
  const updateBonusDone = async (newData) => {
    try {
      const response = await automobyApi.post(`/car/update/bonus/done`, newData);
      return response.data;
    } catch (error) {
      console.error(error);
    } 
  }
 
  const updateIsArchive = async (newData) => {
    try {
      const response = await automobyApi.post(`/car/update/archive`, newData);
      return response.data;
    } catch (error) {
      console.error(error);
    } 
  }

  const carService = {
    cars: cars,
    totalCars: totalCars,
    filter: filter,
    sum: sum,
    firstReached: firstReached,
    setFilter: setFilter,
    statByYear: statByYear,
    addCar: addCar,
    updateCar: updateCar,
    deleteCar: deleteCar,
    updateStatus: updateStatus,
    updateMarine: updateMarine,
    updateFeedbackId: updateFeedbackId,
    updateFeedbackServiceId: updateFeedbackServiceId,
    updateInsurance: updateInsurance,
    updateService: updateService,
    updateClientPrice: updateClientPrice,
    updateCompanyPrice: updateCompanyPrice,
    updateSalerPrice: updateSalerPrice,
    updateBlNumber: updateBlNumber,
    updateSenderAt: updateSenderAt,
    listSum: listSum,
    getStat: getStat,
    fetchCars: fetchCars,
    fetchAllCars: fetchAllCars,
    fetchAppData: fetchAppData,
    resetDefault: resetDefault,
    updateColorComment: updateColorComment,
    nextPage: nextPage,
    prevPage: prevPage,
    downloadReport: downloadReport,
    fetchByDealerId: fetchByDealerId,
    fetchByDealerIdDebt: fetchByDealerIdDebt,
    fetchByDealerIdDeposit: fetchByDealerIdDeposit,
    downloadFile: downloadFile,
    updateContainerNumber: updateContainerNumber,
    updateTransitNumber: updateTransitNumber,
    updateDepositPaid: updateDepositPaid,
    downloadExcel: downloadExcel,
    downloadPdfBonus: downloadPdfBonus,
    updateDocIssuer: updateDocIssuer,
    updateFinalRecipient: updateFinalRecipient,
    fetchClientPrices: fetchClientPrices,
    uploadInvoice: uploadInvoice,
    getCarById: getCarById,
    getCarPhotosById: getCarPhotosById,
    getCarPhotosDownloadById: getCarPhotosDownloadById,
    updateCarPage: updateCarPage,
    addCarPage: addCarPage,
    initData: initData,
    calculatePrice: calculatePrice,
    resetPrices: resetPrices,
    updateBonusDone: updateBonusDone,
    updateIsArchive: updateIsArchive,
    totalPaidCars: totalPaidCars,
  };

  return { carService };
}